import { axiosPost } from '@/api/AxiosApi';

export const totalInAppBalance = async () => {
  const payload = {
    path: '/v1/point/inApptotalBalance',
  };
  const { data: re } = await axiosPost(payload);
  return re;
};
